const route = {
	path: '/accountant/:id/:name/:subsidiaryName/:year/accounting-accounts',
	name: 'accounting-accounts',
	meta: {
		title: 'Cuentas Contables',
		noChangeCompany: true,
	},
	component: () => import('@/pages/accounting-accounts/page-accounting-account'),
	props: true,
	children: [
		{
			path: 'new',
			name: 'accounting-account-new',
			meta: {
				title: 'Crear Cuenta Contable',
			},
			component: () => import('@/pages/accounting-accounts/page-accounting-account-new'),
			props: true,
		},
		{
			path: ':accountId/edit',
			name: 'accounting-account-edit',
			meta: {
				title: 'Editar Cuenta Contable',
			},
			component: () => import('@/pages/accounting-accounts/page-accounting-account-new'),
			props: true,
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/accounting-accounts.js